import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VouchersComponent } from './components/vouchers/vouchers.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationVoucherComponent } from './components/location-voucher/location-voucher.component';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@NgModule({
  declarations: [VouchersComponent, LocationVoucherComponent],
  exports: [VouchersComponent, LocationVoucherComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgbModule,
    ErrorsModule,
    PipesModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
})
export class VouchersModule {}
